import jwtDecode from "jwt-decode";

class Jwt {
  static decode(jwt) {
    return jwtDecode(jwt);
  }
}
export default Jwt;
